"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var RangeButtons = function RangeButtons(_ref) {
  var label = _ref.label,
    alert = _ref.alert,
    count = _ref.count,
    className = _ref.className,
    disabled = _ref.disabled,
    _onClick = _ref.onClick,
    tooltip = _ref.tooltip,
    minusDisabled = _ref.minusDisabled,
    plusDisabled = _ref.plusDisabled,
    plusButtonClassName = _ref.plusButtonClassName,
    minusButtonClassName = _ref.minusButtonClassName;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('d8-c-range-buttons flex justify-between', className, alert && alert.notificationType)
  }, label && /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex flex-center"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label width-auto d8-u-color-contrast-medium",
    htmlFor: label.replace(/\s+/g, '-').toLowerCase(),
    "data-section": "form-label"
  }, label), tooltip && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-left-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: "info-i-fill",
    fill: _constants.COLORS.CONTRAST_MEDIUM
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center justify-end"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: minusButtonClassName,
    buttonType: disabled || minusDisabled ? _constants.BUTTON_TYPES.SQUARE_ICON_DISABLED : _constants.BUTTON_TYPES.SQUARE_ICON,
    icon: "minus",
    onClick: function onClick() {
      return _onClick(-1);
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-x-xs d8-u-text-bold count text-center min-width-25%"
  }, count), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: plusButtonClassName,
    buttonType: disabled || plusDisabled ? _constants.BUTTON_TYPES.SQUARE_ICON_DISABLED : _constants.BUTTON_TYPES.SQUARE_ICON,
    icon: "plus",
    onClick: function onClick() {
      return _onClick(1);
    }
  })), alert && /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    className: "margin-top-sm",
    show: alert.showNotification,
    text: alert.notificationMessage,
    type: alert.notificationType,
    onClose: alert.onClose
  }));
};
RangeButtons.propTypes = {
  label: _propTypes["default"].string,
  className: _propTypes["default"].string,
  alert: _propTypes["default"].object,
  count: _propTypes["default"].number,
  onClick: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  minusDisabled: _propTypes["default"].bool,
  plusDisabled: _propTypes["default"].bool,
  tooltip: _propTypes["default"].string
};
RangeButtons.defaultProps = {
  count: 0
};
var _default = exports["default"] = RangeButtons;